export default "__VITE_ASSET__3aefbc4b__"